import { Checkbox } from 'vopay';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './BankConnectionTermsAndConditions.module.scss';

type TermsAndConditionsTexteProps = {
  title: string;
  accepted: boolean;
  onChange: () => void;
} & (
  | {
      htmlContent: string;
      pdfUrl?: never;
    }
  | {
      htmlContent?: never;
      pdfUrl: string;
    }
);

const TermsAndConditionsText: FC<TermsAndConditionsTexteProps> = ({
  title,
  htmlContent,
  pdfUrl,
  accepted,
  onChange,
}) => {
  const { t } = useTranslation('translations', { keyPrefix: 'BankConnection' });

  if (!htmlContent && !pdfUrl) {
    return null;
  }

  return (
    <div className={styles.termsAndConditionsTextContainer}>
      {htmlContent && (
        <div
          dangerouslySetInnerHTML={{ __html: htmlContent }}
          className={styles.termsAndConditionsScrollableTextArea}
        />
      )}

      {pdfUrl && (
        <object data={`${pdfUrl}#toolbar=1&scrollbar=1&view=fitH`} type="application/pdf" width="100%" height="300px">
          <p>
            <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
              Open in new tab
            </a>
          </p>
        </object>
      )}
      <div className={styles.acceptCheckBoxAccordion}>
        <Checkbox
          name={`accept-${title}`}
          value={accepted}
          hasNoPadding
          onBlur={() => {}}
          onChange={onChange}
          variant="paylink"
        />
        <div>
          {t('accept') || ''} {title}
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsText;
